import { gql } from '@apollo/client'

import type { QueryVars } from '@/lib/apollo/query/getTotalActivitiesByDateForUser/query'

export type { QueryVars }

export type DateTotalCompletedActivitiesResponse = {
  date: string
  totalActivities: number
}

export type Response = {
  getTotalActivitiesByDateForUser: DateTotalCompletedActivitiesResponse[]
}

const query = gql`
  query (
    $userId: String!
    $customerId: String!
    $startDate: String!
    $endDate: String!
    $filters: GetTotalActivitiesByDateForUserFilters
    $timeInterval: TimeInterval!
  ) {
    getTotalActivitiesByDateForUser(
      userId: $userId
      customerId: $customerId
      startDate: $startDate
      endDate: $endDate
      filters: $filters
      timeInterval: $timeInterval
    ) {
      date
      totalActivities
    }
  }
`

export default query
